
var all = new Group();
function rgb(){
  return ["red","blue","green","yellow","orange","purple"][num(6)];
}
var width = 3+num(25);
var height = 3+num(25);

function tiles(width,height){
  var size = Math.min(view.bounds.height,view.bounds.height)/(2+width)
  var lines = new Group();
  var cellSize = new Point(view.bounds.width/width,view.bounds.height/height);

  var bunches = new Group();
  for (var i = 0; i < width; i++) {
    for (var j = 0; j < height; j++) {
      var pt = new Point(size/2,size/2);
      var theGroup = bunch(cellSize);
      theGroup.fitBounds(new Size(cellSize));
      theGroup.position += [cellSize.x*i,cellSize.y*j];
      theGroup.scale(.88-Math.random()*.1);
      bunches.children.push(theGroup)
    }
  }
  all.children.push(bunches);
}

function bunch(cellSize){
  var amt = num(3)+1;
  var out = new Group();
  for (var i = 0; i < amt; i++) {
    out.children.push(shp(cellSize));
  }
  return out;
}

function shp(size){
  var numberz = 2//(.2+Math.random()*.5)
  var thePoint = [size.x*(.3+Math.random()*.5),size.y*(.3+Math.random()*.5)]//[numberz*size.x,numberz.y*size];
  var methods = [
    function(){
      var c = new Path.Circle(thePoint,Math.min(size.x,size.y)/(Math.random()+3));
      c.fillColor = rgb();
      c.rotate(num(20))
      return c;
    },
    function(){
      var t = new Path.RegularPolygon({
        center: thePoint,
        sides: 3,
        radius: Math.min(size.x,size.y)/(Math.random()+2.3),
        fillColor: rgb()
      });
      t.rotate(num(180)-90)
      return t;
    },
    function(){
      var sizes = [size.x*(.2+Math.random()*.2),size.x*(.2+Math.random()*.2)];
      var x = num((size.x-sizes[0]));
      var y = num((size.y-sizes[1]));
      var r = new Path.Rectangle(x,y,sizes[0],sizes[1]);
      r.fillColor = rgb();
      r.rotate(num(10)-5)
      return r;
    }
  ]
  return methods[num(3)]();
}

tiles(width,height)

function onMouseDown(e){
  project.activeLayer.clear();
  tiles(width,width)
  width = 3+num(5);
  height = 3+num(5);
}
